import React, { useState } from "react";
import axios from "axios";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Lock, Loader2, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { toast } from "sonner";
import { useNavigate, useSearchParams } from "react-router-dom";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const SellerResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        new_password: "",
        confirm_password: ""
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!token) {
            return toast.error("Lyen an pa valab. Tanpri chache yon nouvo lyen.");
        }
        if (formData.new_password !== formData.confirm_password) {
            return toast.error("Modpas yo pa sanble!");
        }
        if (formData.new_password.length < 6) {
            return toast.error("Modpas la dwe gen omwen 6 karaktè.");
        }

        setLoading(true);
        try {
            const response = await axios.post(`${API}/sellers/reset-password`, { 
                token: token, 
                new_password: formData.new_password 
            });
            if (response.data.success) {
                toast.success(response.data.message || "Modpas chanje ak siksè!");
                navigate("/seller/login");
            }
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erè. Lyen an kapab ekspire.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />

            <div className="flex-1 flex items-center justify-center px-4 py-12 bg-gradient-to-b from-gray-50 to-white">
                <div className="max-w-md w-full">
                    <div className="text-center mb-8">
                        <div className="w-20 h-20 bg-[#232F3E] rounded-[30px] flex items-center justify-center mx-auto mb-6 shadow-2xl shadow-[#232F3E]/20">
                            <KeyRound className="w-10 h-10 text-[#FF9900]" />
                        </div>
                        <h1 className="text-3xl font-black text-gray-900 tracking-tighter mb-2 italic">Kreye Nouvo Modpas</h1>
                    </div>

                    <Card className="rounded-[40px] border-none shadow-2xl overflow-hidden bg-white">
                        <CardHeader className="p-10 pb-2 text-center text-black">
                            <CardTitle className="text-xl font-black uppercase tracking-tight">Sekirize Kont Ou</CardTitle>
                            <CardDescription className="text-gray-400 font-medium">Antre nouvo modpas ou ta renmen itilize a pou magazen ou a.</CardDescription>
                        </CardHeader>
                        <CardContent className="p-10 pt-6">
                            {!token ? (
                                <div className="text-center py-6">
                                    <p className="text-red-500 font-bold mb-4">Ou pa gen lyen sekrè pou chanje modpas la!</p>
                                    <Button onClick={() => navigate("/seller/login")} variant="outline" className="h-12 w-full rounded-2xl">
                                        Tounen nan Login
                                    </Button>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1">Nouvo Modpas</label>
                                        <div className="relative group">
                                            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                            <Input
                                                type="password"
                                                placeholder="••••••••"
                                                className="pl-12 h-14 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black"
                                                value={formData.new_password}
                                                onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1">Konfime Nouvo Modpas</label>
                                        <div className="relative group">
                                            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                            <Input
                                                type="password"
                                                placeholder="••••••••"
                                                className="pl-12 h-14 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black"
                                                value={formData.confirm_password}
                                                onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <Button
                                        type="submit"
                                        disabled={loading}
                                        className="w-full bg-[#FF9900] hover:bg-black text-white h-16 rounded-[25px] font-black text-lg transition-all hover:scale-[1.02] shadow-xl shadow-orange-500/20"
                                    >
                                        {loading ? <Loader2 className="animate-spin w-6 h-6" /> : "CHANJE MODPAS LA"}
                                    </Button>
                                </form>
                            )}
                        </CardContent>
                    </Card>
                </div>
            </div>

            <Footer />
        </div>
    );
};
